<div class="modal-header">
  <h4 class="modal-title">{{ "support.add_comment" | translate }}</h4>
  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" ngbAutofocus>
  <myp-inline-loader [loading]="loading" height="200px" spinnerName="ticketAddCommentLoader"></myp-inline-loader>

  @if (!loading) {
    <div>
      <div class="form-group">
        <label for="comment" class="control-label">{{ "support.enter_comment" | translate }}</label>
        <textarea id="comment" class="form-control" [(ngModel)]="comment"></textarea>
      </div>
      @if (ticket.can_be_solved_by_me) {
        <div class="form-group col-md-12">
          <input class="form-check-input" type="checkbox" [(ngModel)]="solved" id="solved" />
          <label class="form-check-label" for="solved">{{ "support.mark_as_resolved" | translate }}</label>
        </div>
      }
      <div class="form-group">
        <label class="control-label">{{ "general.add_attachments" | translate }}</label>
        <input type="file" ng2FileSelect [uploader]="uploader" />
        <!-- <div>
        <small>Accepted file types: png, jpg, gif, pdf, doc, docx, odt, txt, xml, json, wav, mp4, mov</small>
      </div> -->
      </div>
      @if (uploader && uploader.queue.length && uploader.isUploading) {
        <div>
          @for (item of uploader.queue; track item) {
            <div class="text-center" style="position: relative">
              <span style="color: gray; font-size: 16px; text-align: center; font-family: Lato; font-weight: bold">{{ "general.uploading" | translate }} {{ item?.file?.name }}</span>
              <br />
              <br />
              <div style="display: inline-block; margin: auto">
                <round-progress
                  [current]="item.progress"
                  max="100"
                  [color]="'#45ccce'"
                  [background]="'#eaeaea'"
                  [radius]="100"
                  [stroke]="10"
                  [semicircle]="false"
                  [rounded]="true"
                  [clockwise]="true"
                  [responsive]="false"
                  [duration]="250"
                  [animation]="'easeInOutQuart'"
                  [animationDelay]="0"
                ></round-progress>
              </div>
              <br />
              @if (!uploadingComplete) {
                <span class="uploading-label">{{ item?.progress }}%</span>
              }
              @if (uploadingComplete && !fileResponse) {
                <span class="uploading-label">{{ "general.processing_dots" | translate }}</span>
              }
            </div>
          }
        </div>
      }
      @if (attachments && attachments.length) {
        <div>
          <label class="control-label">Attachments</label>
          @for (attachment of attachments; track attachment) {
            <div>
              {{ attachment.upload.attachment.file_name }}
            </div>
          }
        </div>
      }
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="submit()">{{ "general.send" | translate }}</button>
  <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
</div>
